<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col class="pt-6" cols="2">
        <v-card width="250">
          <v-navigation-drawer permanent left>
            <v-list>
              <v-list-item v-for="item in items" :key="item.title" :to="item.link">
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-card>
      </v-col>
      <v-col cols="10">
        <div class="ml-4">
          <router-view />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        //{ title: "Coaching", icon: "mdi-whistle-outline", link: "/reporting/company/coaching" },
        { title: "Operations", icon: "mdi-developer-board", link: "/reporting/company/operations" },
      ],
    };
  },
};
</script>
